import { render } from "./manage_reports.html?vue&type=template&id=5575d7c4&external"
import script from "./manage_reports.js?vue&type=script&lang=js&external"
export * from "./manage_reports.js?vue&type=script&lang=js&external"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__